import { envConfig } from "~/config/env";

/**
 * Deploy / build kill switch. Recording and signal upload stay off when the
 * runtime or build env sets `VITE_TAX_SESSION_REPLAY=off`.
 */
export function isSessionReplayAllowed(): boolean {
  return envConfig.sessionReplay !== "off";
}
